import { urls } from "../common/constant";
import { actionTypes } from "./ActionTypes";
import http from "../assets/extra/_httpServices";


export const updateLoadingScreen = (data) => {
    return {
        type: actionTypes.UPDATE_LOADING_SCREEN,
        payload: data,
    }
}
export const updateLoginDetails = (data) => {
    return {
        type: actionTypes.USER_LOGIN,
        payload: data,
    }
}
export const logOut = () => {
    sessionStorage.clear()
    window.location.reload();
    return {
        type: actionTypes.LOGOUT,
    }
}
export const updateAuthLoaded = (data) => {
    return {
        type: actionTypes.AUTH_LOADED,
        payload: data,
    }
}
export const userLogin = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpGet(urls.userLogin, data)
            .then((res) => {
                if (res?.data?.status && Object.keys(res.data.Data).length > 0) {
                    dispatch({
                        type: actionTypes.USER_LOGIN,
                        payload: res.data.Data || {},
                    });
                    sessionStorage.setItem('userDetails', JSON.stringify(res.data.Data || {}));
                    sessionStorage.setItem('token', res?.data?.Data?.token);
                    dispatch(getServerTime(res?.data?.Data?.token))
                }
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};

export const getServerTime = (logintoken = null) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            http
                .HttpGet(urls?.getServerTime, {}, logintoken)
                .then((response) => {
                    let seriveTime = new Date(response?.data)
                    let localTime = new Date()
                    let diff = seriveTime?.valueOf() - localTime?.valueOf()
                    sessionStorage.setItem('timeConfig', JSON.stringify({ seriveTime, localTime, diff }))
                    return resolve(response);
                })
                .catch((error) => {
                    console.log("Error: ", error);
                    reject(error);
                });
        })
    };
};

export const updateShowAlert = ({ message, severity = 'error', btnText = 'OK', nextId = '', open = true }) => ({
    type: actionTypes.SHOW_ALERT,
    payload: { message, severity, btnText, open, nextId },
});


export const showErrorAlert = (message, nextId = '', btnText = 'OK',) => updateShowAlert({ message, severity: 'error', btnText, nextId });
export const showSuccessAlert = (message, nextId = '', btnText = 'OK',) => updateShowAlert({ message, severity: 'success', btnText, nextId });
export const hideAlert = () => updateShowAlert({ message: '', severity: '', btnText: '', nextId: '', open: false });